import React, { useState, useEffect } from "react"
import crossIcon from "../../images/icon-close.png"
import { Link, Redirect } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons"
import { DEFAULT_IMG_URL } from "../constants/carMileage"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Button, Image } from "semantic-ui-react"
import { getClearCoverURL, getZebraURL } from "../actions/insurance"
import { getLogo, getSplitIOForFeatures, getUserDetails } from "../actions/user"
import { getPartnerFeatureFlag } from "../../shared_component/utils/partnerFeatureFlag"
import { trackEvent } from "../../shared_component/utils/segmentAnalytics"

const ChooseCoverage = ({
  user,
  t,
  getClearCoverURL,
  getZebraURL,
  getUserDetails,
  getLogo,
  getSplitIOForFeatures,
  ...other
}) => {
  const [userData, setUserData] = useState()
  const [image, setImage] = useState(null)
  const [zebra, setZebra] = useState(false)
  const [clearcover, setClearcover] = useState(false)
  const [isDisplay, setIsDisplay] = useState("d_none")
  const [zebraUrl, setZebraUrl] = useState()
  const [clearcoverUrl, setClearcoverUrl] = useState()
  const [splitResponse, setSplitResponse] = useState()
  const [clearcoverDisabled, setClearcoverDisabled] = useState(false)
  const [partnerFlag, setPartnerFlag] = useState()

  useEffect(() => {
    getFeatureFlagResult()
  }, [])

  const getFeatureFlagResult = async () => {
    const result = await getPartnerFeatureFlag(user)
    setPartnerFlag(result)
  }

  const redirectClearcover = async () => {
    const data = {
      firstname: userData.firstName,
      lastname: userData.lastName,
      zip: userData.zip,
      vin: userData.active_vehicle.vin,
      mileage: userData.active_vehicle.miles
    }
    let responseData = await getClearCoverURL(data)
    setClearcoverUrl(responseData.result.return_url)
  }

  const redirectZebra = async () => {
    const data = {
      mileage: userData.active_vehicle.miles,
      vehicle_id: userData.active_vehicle.id
    }
    let responseZebra = await getZebraURL(data)
    setZebraUrl(responseZebra.result.location)
  }

  const _getUserDetails = async () => {
    let response = await getUserDetails()
    setUserData(response && response.result)
    setClearcoverDisabled(response && response.result.active_vehicle.vin ? false : true)
  }

  useEffect(() => {
    _getUserDetails()
  }, [])

  const logoApi = async () => {
    const response = await getLogo()
    setImage(response && response.result)
  }

  useEffect(() => {
    logoApi()
  }, [])

  const handleZebra = async (e) => {
    setIsDisplay("d_flex")
    setZebra(!zebra)
    redirectZebra()
  }

  const handleClearcover = (e) => {
    setIsDisplay("d_flex")
    setClearcover(!clearcover)
    redirectClearcover()
  }

  const handleClose = (e) => {
    setIsDisplay("d_none")
    setZebra(false)
    setClearcover(false)
  }

  useEffect(() => {
    getSplitIODetails()
  }, [])

  const getSplitIODetails = async () => {
    const response = await getSplitIOForFeatures("insurance")
    setSplitResponse(response.result)
  }

  return (
    <>
      {partnerFlag === false ? (
        <Redirect to="/dashboard" />
      ) : (
        <>
          <div className="choose-coverage-section">
            <div className="choose-coverage">
              <div className="step-title">
                <Link to="/insurance-car-mileage">
                  <FontAwesomeIcon icon={faArrowLeft} />
                </Link>
                <h3>{t("Step2_Choose_coverage")}</h3>
              </div>
              <p className="current_plan">{t("Find_right_coverage")}</p>
              <div className="form-parent">
                <div className="col-6 left-child">
                  {splitResponse && splitResponse.zebra ? (
                    <div className="insurance_card">
                      <div className="insurance_image">
                        <Image className="logo-image zebra" src={image && image.zebra} />
                      </div>
                      <Button className="insurance_button" onClick={handleZebra}>
                        {t("Get_a_quote")}
                      </Button>
                    </div>
                  ) : null}
                  {splitResponse && splitResponse.clearcover ? (
                    <div className="insurance_card">
                      <div className="insurance_image">
                        <Image className="logo-image" src={image && image.clearcover} />
                      </div>
                      <Button
                        className="insurance_button"
                        onClick={handleClearcover}
                        disabled={clearcoverDisabled}
                      >
                        {t("Get_a_quote")}
                      </Button>
                      {clearcoverDisabled ? (
                        <span className="require-text">
                          {t("VIN_unavailable")}&nbsp;
                          <a href="#/managevehicles" className="garage_text">
                            {t("Go_to_garage")}
                          </a>
                          &nbsp;
                          {t("update_to_proceed_further")}
                        </span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="right-child">
                  <span className="img-strip">
                    <Image
                      className="car_img"
                      src={
                        userData &&
                        userData.active_vehicle.images &&
                        userData.active_vehicle.images[0]
                          ? userData.active_vehicle.images[0].url
                          : DEFAULT_IMG_URL
                      }
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={`insurance-modal ${isDisplay}`} onClick={handleClose}>
            <div className="insurance-content">
              <div className="modal-heading">
                <h4>{t("Continue_to_external_site")}</h4>
                <span onClick={handleClose}>
                  <Image className="logo-image" src={crossIcon} />
                </span>
              </div>
              <p>{t("Redirected_to_external_website")}</p>
              <a
                href={zebraUrl}
                target="_blank"
                className={`redirecting-button ${zebra ? "zebra-btn" : ""}`}
                onClick={() => trackEvent("insurance-plan-zebra-clicked", {}, true, false, false)}
              >
                <Image className="logo-image" src={image && image.zebra} />
              </a>
              <a
                href={clearcoverUrl}
                target="_blank"
                className={`redirecting-button ${clearcover ? "clearcover-btn" : ""}`}
                onClick={() =>
                  trackEvent("insurance-plan-clearcover-clicked", {}, true, false, false)
                }
              >
                <Image className="logo-image" src={image && image.clearcover_white} />
              </a>
            </div>
          </div>
        </>
      )}
    </>
  )
}

function mapStateToProps(state) {
  let user = state.user

  return {
    user: user
  }
}

export default connect(mapStateToProps, {
  getClearCoverURL,
  getZebraURL,
  getUserDetails,
  getLogo,
  getSplitIOForFeatures
})(withTranslation("chooseCoverage")(ChooseCoverage))
